import ReactStrapTable from "components/reactStrapTable";
import React, { useEffect, useState } from "react";
import HoverImage from "react-hover-image/build";
import { ModuleAccess } from "utils/moduleaccess";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { cellRendererCheck, dateFormate } from "utils/columns";
import Maping from "assets/icon/MapIcon.svg";
import MapHover from "assets/icon/MapIconHover.svg";
import UnMapped from "assets/icon/UnMapped.svg";
// import UnMappedHover from "assets/icon/UnMappedHover.svg"
import View from "assets/icon/icon-icon-options-view-patient.svg";
import ViewHover from "assets/icon/icon-icon-options-view-patient_hover.svg";
import useAxios from "hooks/useAxios";
import { cloneDeep } from "lodash";
import { toast } from "react-toastify";
import save from "assets/icon/save.svg";

const dummyData = [
  {
    edit: null,
    chargeCode: "CC1001",
    chargeDescription: "General Consultation",
    ndc: "12345-6789",
    pendingutlizationcount: 5,
    createddate: "2025-08-01T10:30:00Z",
    modifeddate: "2025-08-05T12:00:00Z",
    modifiedby: "jane.doe",
    responsiveflag: "Yes",
    ndcDescription: "Basic Health Service",
    lastInvoicedDate: "2025-07-30T14:00:00Z",
    startDate: "2025-08-01T09:00:00Z",
  },
  {
    edit: null,
    chargeCode: "CC1002",
    chargeDescription: "X-ray Imaging",
    ndc: "98765-4321",
    pendingutlizationcount: 2,
    createddate: "2025-07-15T08:00:00Z",
    modifeddate: "2025-07-18T09:30:00Z",
    modifiedby: "john.smith",
    responsiveflag: "No",
    ndcDescription: "Radiology",
    lastInvoicedDate: "2025-07-20T11:15:00Z",
    startDate: "2025-07-10T10:00:00Z",
  },
  {
    edit: null,
    chargeCode: "CC1003",
    chargeDescription: "Blood Test",
    ndc: "11111-2222",
    pendingutlizationcount: 10,
    createddate: "2025-06-20T13:45:00Z",
    modifeddate: "2025-06-25T14:30:00Z",
    modifiedby: "alice.wong",
    responsiveflag: "Yes",
    ndcDescription: "Lab Service",
    lastInvoicedDate: "2025-06-28T09:30:00Z",
    startDate: "2025-06-19T08:00:00Z",
  },
];

const HiddenNDCTable = (props) => {
  const {
    unmapedChargeCount,
    manvalConfigedit,
    manvalConfig,
    manvalPharmacy,

    data,
    totalSize,
    unmapedNdcCount,
    filters,
    orgId,

    searchTerms,
    search,
    onExport,
    onclick,
    refetch,
    load,
    toggleSider,
    collapseSider,
    setNdcMapingFlag,
    ndcmapingflag,
    resetFilterFlag,
    SetResetFilterFlag,
    ndckey,
    crosswalkNdcsearch,
    setLoading,
    loading,
    setTotalHideRecords,
    hiddenrecords,
    searchNdcCode,
    setSearchChargeCode
  } = props;
  const API = useAxios();
  const [hiddentableData, setHiddenTableData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [selectedrow, setSelectedRow] = useState({});
  const [initialValues, setInitialValues] = useState({
    ...crosswalkNdcsearch,
  });

useEffect(()=>{
 setIsOpen(false);
 setHiddenTableData([]);
 setTotalHideRecords(0);
},[orgId,resetFilterFlag])

  const [columnFilters, setColumnFilters] = useState([]);
  useEffect(() => {
    fetchHiddenndcs(initialValues);
  }, [ndckey,searchNdcCode]);
  const handelToggle = () => {
    setIsCheck(false);
    setIsOpen(!isOpen);
  };
  const fetchHiddenndcs = async (initialValues) => {
    debugger;
    if (ndckey != "hidendcs") return null;
    setLoading(true);
    initialValues.AccumulatorID = crosswalkNdcsearch.AccumulatorID;
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/HiddenNDCs`,
        initialValues,
        { hasDefaultURL: true }
      );
      if (data?.items?.length > 0) {
        setHiddenTableData(data.items);
        setTotalHideRecords(data.totalRecords);
        setLoading(false);
      } else {
        setHiddenTableData([]);
        setTotalHideRecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const handelUnHideNdc = async (rowData, status) => {
    setLoading(true);
    let orderDrugID = rowData.orderDrugID;

    try {
      const { data } = await API.get(
        `SBTenant/${orgId.tenantID}/CrossWalk/HiddenAndUnHiddenNDC/${orderDrugID}/${status}/${isCheck}`,

        { hasDefaultURL: true }
      );
      if (data.error == false) {
        // setHiddenTableData(data.items);
        // setTotalHideRecords(data.totalRecords);
        setLoading(false);
        toast.success(data.message);
        fetchHiddenndcs(initialValues);

        handelToggle();
      } else {
        setHiddenTableData([]);
        setTotalHideRecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const handleFilterCancel = () => {
    setColumnFilters([]);
    initialValues.filters = cloneDeep([]);
    initialValues.currentPage = cloneDeep(1);
    fetchHiddenndcs(initialValues);
  };
  const onPageChange = (filter, haveColFilter) => {
    debugger;
    if (haveColFilter) {
      const filterObj = cloneDeep(initialValues);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.order  = filter.order;
      filterObj.orderBy= filter.orderBy;
      setInitialValues({
        currentPage: filter.currentPage,
        pageSize: filter.pageSize,
        ...filter,
      });
      // initialValues.currentPage = filter.currentPage;
      // initialValues.pageSize = filter.pageSize;
      // initialValues = { ...initialValues, ...filter };
      debugger;
      fetchHiddenndcs(filterObj);
    } else {
      debugger;

      fetchHiddenndcs(filter);
      setInitialValues({ ...initialValues, ...filter });
    }
    //updateStates(crosswalkQueue);
  };
  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      // setColFilters(colFilter);
    }
  };
  const onSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(crosswalkNdcsearch);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setColumnFilters(columnFilters);
    }
    debugger;

    filterObj.currentPage = 1;
    initialValues.currentPage = cloneDeep(1);
    await fetchHiddenndcs(filterObj);
  };
  const handelSubmit = () => {
    handelUnHideNdc(selectedrow, "unhide");
  };
  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 117,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: "drugDescription",
      text: "NDC Description",
      sort: true,
      width: 240,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.drugDescription),
    },
    {
      dataField: "gcnSequenceNumber",
      text: "GCN",
      sort: true,
      width: 180,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.gcnSequenceNumber),
    },
    // {
    //   dataField: "hiddenNDCFlag",
    //   text: "Hidden Flag",
    //   sort: true,
    //   width: 200,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck(row.hiddenNDCFlag),
    // },
    {
      dataField: "lastInvoicedDate",
      text: "Last Invoiced Date",
      sort: true,
      width: 140,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => dateFormate(row.lastInvoicedDate),
    },
    {
      dataField: "lastInvoicedQty",
      text: "Last Invoiced Qty",
      sort: true,
      width: 137,

      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.lastInvoicedQty),
    },
    {
      dataField: "packageSize",
      text: "Package Size",
      sort: true,
      width: 180,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.packageSize),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 160,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    },
  ];
  const renderMapping = (rowData) => {
    if (rowData.isEdit != true)
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => togglemapingview(rowData)}
          title="Map"
        >
          <HoverImage key="Maping" src={Maping} hoverSrc={MapHover} alt="" />
        </Button>
      );
  };
  const toggleHide = (rowData) => {
    debugger;
    console.log(rowData, "rowdata");
    setSelectedRow(rowData);
    handelToggle();
  };

  const hasPermission = (code) => {
      return ModuleAccess("CRW", code);
    };
    
  const renderUnMapped = (rowData) => {
     if (hasPermission("HI"))
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => toggleHide(rowData)}
        title="Unhide"
      >
        <HoverImage key="unhide" src={View} hoverSrc={ViewHover} alt="" />
      </Button>
    );
  };
  const cellRenderEdit = (rowData) => {
    return (
      <div className="d-flex align-items-center">{renderUnMapped(rowData)}</div>
    );
  };
  const handelChecked = () => {
    setIsCheck(!isCheck);
  };
  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(crosswalkNdcsearch);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem("pharmaforce")) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;

    var payload = {};
    payload.tenantID = orgId.tenantID;
    payload.gridCode = "crosswalkhiddenndc";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };
  return (
    <div>
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={hiddentableData?.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="hiddenndc-table"
          height={550}
          fixedColumn
          width={1200}
          hasPagination
          // reset={reset}
          data={hiddentableData}
          columns={mainCol}
          onExport={handleExport}
          filters={initialValues}
          totalRecords={hiddenrecords}
          pageSize={initialValues.pageSize}
          currentPage={initialValues.currentPage}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          toggleSider={toggleSider}
          collapseSider={collapseSider}
          showtoggle={true}
          resetFilterFlag={resetFilterFlag}
          SetResetFilterFlag={SetResetFilterFlag}
          // hasExportPermission={hasExportPermission}
        />
      </div>
      <Modal isOpen={isOpen} toggle={handelToggle} size="lg" className="md">
        <ModalHeader toggle={handelToggle}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            NDC Order Exclusion
          </h5>
        </ModalHeader>
        <ModalBody className="m-2 p-2">
          <div>
            <p className="f-13 text-primary font-weight-600 mt-2">
              You have chosen to unhide this NDC from the crosswalk. This action
              will add this NDC from your unmapped NDC list and allow mapping of
              this NDC to a charge code.
            </p>
            <div className="d-flex justify-content-between">
              <Input type="checkbox" value={isCheck} onClick={handelChecked} />
               &nbsp;&nbsp;
              <p className="f-13 font-weight-600">
                Would you also like to remove this NDC from the NDC Exclusion
                list? By removing the NDC from the exclusion list,all orders
                going forward will split to the account base on accmulations.
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            style={{ width: "160px" }}
            className="search"
            onClick={handelSubmit}
          >
            <span className="right_5">
              <img src={save} alt="" />
            </span>{" "}
            Apply & Save
          </Button>{" "}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default HiddenNDCTable;
